import {
  Component,
  ViewChild,
  Input,
  OnInit,
  Output,
  EventEmitter,
} from "@angular/core";
import { CdkConnectedOverlay, CdkOverlayOrigin } from "@angular/cdk/overlay";
import * as _ from "lodash";

@Component({
  selector: "demo-text-en",
  templateUrl: "./text-en.component.html",
  styleUrls: ["./text-en.component.scss"],
})
export class TextEnComponent implements OnInit {
  @Input() langConfig: Array<any> = [
    { language: "zh-cn", label: "中", value: "" },
    { language: "en", label: "英", value: "" },
  ];

  @Input() labelI18n: Array<any> = [
    { language: "zh-cn", label: "中", value: "" },
    { language: "en", label: "英", value: "" },
  ];
  @Output() inputChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(CdkOverlayOrigin, { static: false })
  cdkOverlayOrigin: CdkOverlayOrigin | undefined;
  triggerWidth = "260px";
  languageList: any[] = [];
  constructor() {}

  resize(event: any) {
    this.visibleChange(event);
  }
  ngOnInit() {
    this.setLanguageList();
  }

  setLanguageList() {
    this.languageList = _.cloneDeep(this.langConfig);
    if (!_.isEmpty(this.languageList)) {
      if (!_.isEmpty(this.labelI18n)) {
        this.languageList.forEach((ele: any) => {
          this.labelI18n.forEach((el: any) => {
            if (ele.language === el.language) {
              ele.value = el.value;
            }
          });
        });
      }
    }
    return this.languageList;
  }

  onChange(value: any) {
    this.inputChange.emit(this.languageList);
  }

  visibleChange(event: any) {
    if (event) {
      if (this.cdkOverlayOrigin !== undefined) {
        this.triggerWidth =
          this.cdkOverlayOrigin.elementRef.nativeElement.getBoundingClientRect()
            .width -
          0 +
          "px";
      }
    }
  }
}
